import { SchemaRecord } from "../SchemaRecord.js";

export class ContactsListConnectRequestsParams extends SchemaRecord {
  static type = "chat.params.contacts_list_connect_requests";
  static schema = {};
}
